import { useFrontendTool } from "@copilotkit/react-core"
import biSo from "stores/bi"
import farmSo from "stores/farm"
import { getUrlByPageId } from "stores/route/utils/pagesId"
import { PAGE_ID } from "stores/route/utils/types"
import { waitNavigate } from "./utils"
import { TOOLS } from "./utils/types"
import { useHistory } from "react-router"
import locationSo from "stores/route/location"
import { delayUntil } from "utils"



/**
 * Prmette di utilizzare una PIVOTGRID
 */
export function usePivotgrid() {

	const history = useHistory()

	useFrontendTool({
		name: TOOLS.SHOW_PIVOT_GRID,
		description: `Visualizza la FARM-SECTION ${PAGE_ID.FARM_BI} Cioè una PIVOT-GRID con i dati di produzione e costi della FARM selezionata.
## A COSA SERVE
- Per visualizzare dati di produzione, filtrare per trovare un set di valori particolari, l'utente chiede di fare minimi, massimi o medie, evidenziare valori importanti. Si può fare tramite definizione di "function_callback".
## A COSA NON SERVE
- Per un quadro generale, ottimizzare i CYCLES, avere statistiche di sintesi usa "show_gantt".
`,
		parameters: [
			{
				name: "function_callback",
				description: `Codice di una funzione javascript in formato string con questa signature:
function select(data: Item[]): number[]
Dove "data" è un array di oggetti di tipo ITEM che rappresentano i dati della PIVOT-GRID e la funzione deve restituire un array di indici che indicano quali elementi di "data" devono essere selezionati.
## ITEM
Il tipo ITEM ha degli ITEM-PROPERTIES che sono :
interface Item {
	// CYCLE id numeric identifier
	cycleId: number
	// CYCLE uuid string identifier
	cycleUuid: string
	// CROP name.
	cropName: string
	// CROP LOT numeric identifier,
	cropLotId: number
	// CROP LOT string identifier
	cropLotUuid: string
	// LOT code
	lotCode: string
	// date when the CYCLE is sown. It is the start of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	seedingDate: string | null
	// date when the CYCLE is harvested. The end of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	harvestingDate: string | null
	// theoretical yield forecast in kg. It is a number
	plannedYield: number | null
	// actual yield in kg. It is a number
	yield: number | null
	// unknown
	plannedYieldBeforeIncidents: number | null
	// yield for a single TROLLEY
	yieldPerTrolley: number | null
	// number of seeds in a single TROLLEY, 
	trolleysToSeed: number | null
	// unknown
	trolleysToHarvest: number | null
	// unknown
	unitsYield: number | null
	// number of INCIDENTS for the current CYCLE
	nOfIncidents: number | null
	// number of kg lost per INCIDENTS
	lostYield: number | null
}
## EXAMPLES:
QUESTION: selects all elements of 'data' that have a yield greater than 300.
ANSWER: 'function select(data) { return data.reduce((acc, item, i) => { if (item.yeld > 300) acc.push(i); return acc }, []) }'
QUESTION: all elements harvested in the years before 2025. 
ANSWER: 'function select(data) { return data.reduce((acc, item, i) => { if (new Date(item.harvestingDate).getFullYear()<2025) acc.push(i); return acc }, []) }'
QUESTION: selects the harvest with the highest yield of all.
ANSWER: 'function select(data) { return [data.reduce((acc, item, i) => { if (item.yield > acc.max) acc = { max: item.yield, index: i }; return acc }, { max: 0, index: -1 }).index] }'
`,
				type: "string",
				required: true,
			},
			{
				name: "visible_properties",
				description: `Un array delle proprietà dell'ITEM cioè ITEM-PROPERTIES che saranno visibili nelle CELLE della PIVOT-GRID.
Se non specificato visualizza quelli attualmente visibili.
`,
				type: "string[]",
				required: false,
			}
		],
		handler: async ({ function_callback, visible_properties }) => {

			if (!farmSo.state.select) return {
				success: false,
				error: `Devi selezionare una FARM prima. Usa il tool ${TOOLS.NAVIGATE_IN_FARM_SECTION} per selezionare una FARM e poi ripeti questa azione.`
			}

			if (locationSo.state.currentPage != PAGE_ID.FARM_BI) {
				const url = getUrlByPageId(PAGE_ID.FARM_BI, farmSo.state.select.id)
				await waitNavigate(url, history)
				await delayUntil(() => !!biSo.state.dataOrig)
			}

			//const select:(item:any, array:any[]) => boolean = new Function(`return ${def}`)()
			const fn: (array: any[]) => number[] = new Function(`return ${function_callback}`)()
			let indexes: number[] = null
			try {
				indexes = fn(biSo.state.data)
			} catch (error) {
				return {
					success: false,
					error: `La funzione javascript fornita ha generato un errore durante l'esecuzione: ${error.message}`
				}
			}
			indexes = indexes?.filter(i => i >= 0 && i < biSo.state.data.length) ?? []
			biSo.setPropertiesFound(indexes)
			// se sono state fornite le visible_properties, aggiorno la visibilità delle proprietà nella library
			const haveProps = visible_properties && visible_properties.length > 0
			if (haveProps) {
				biSo.state.valLibrary.forEach(p => p.visible = visible_properties.includes(p.name))
				biSo.update()
			}
			return {
				success: true,
				message: `${indexes.length == 0 ? "NO ITEMS SELECTED" : `SELECTED ITEMS: ${indexes.length}`}.
${haveProps ? `Visible properties: ${visible_properties.join(", ")}` : ""}
`,
			}
		},
	})

// 	useFrontendTool({
// 		name: TOOLS.SET_PIVOT_GRID_VISIBLE_PROPERTIES_VALUES,
// 		description: `Imposta le sole proprietà degli ITEMS (cioe' gli ITEM-PROPERTIES) che devono essere visibili nelle celle della griglia dei VALUES della PIVOT-GRID.
// `,
// 		parameters: [
// 			{
// 				name: "properties",
// 				description: `Un array delle proprietà di ITEM cioeè ITEM-PROPERTIES (vedi tool: "show_pivot_grid") 
// che saranno visibili nella PIVOT-GRID.
// `,
// 				type: "string[]",
// 				required: true,
// 			}
// 		],
// 		handler: async ({ properties }) => {
// 			biSo.state.valLibrary.forEach(p => p.visible = properties.includes(p.name))
// 			biSo.update()
// 			return {
// 				success: true,
// 				message: `Proprietà visibili aggiornate: ${properties.join(", ")}`
// 			}
// 		},
// 	})
}



